module.exports = __webpack_public_path__ + "img/img7.c5c334bf.svg";